/**
 * Sets state atoms
 *
 * Stores all MTG sets loaded from Firestore.
 * Data is static (only updated weekly by backend), so no real-time subscription needed.
 */
import { atom } from 'jotai';

import type { ScryfallSet } from '@/types/card';

// ============================================================================
// Sets State Atom
// ============================================================================

export interface SetsState {
  data: ScryfallSet[] | undefined;
  isLoading: boolean;
  error: Error | null;
}

/** Atom holding the shared sets state - populated by init, static thereafter */
export const setsStateAtom = atom<SetsState>({
  data: undefined,
  isLoading: true,
  error: null,
});
